module.exports = __webpack_public_path__ + "img/hardware7.5bed113f.png";